module.exports = __webpack_public_path__ + "static/media/geolocalizacion.56093a5f.svg";